<template>
  <nav aria-label="Pagination">
    <ul class="pagination justify-content-center">
      <li :disabled="pageNumber==1" :class="{disabled: pageNumber==0}" v-if="pageNumber > 1">
        <router-link
          class="page-link"
          :to="{query:{...this.$route.query, page:undefined}}"
          @click.native="scrollTop"
          rel="nofollow"
        >First</router-link>
      </li>
      <li :class="{disabled: pageNumber==1}" v-if="pageNumber > 1">
        <router-link
          class="page-link"
          :to="{query:{...this.$route.query, page: (pageNumber == 2) ? undefined: pageNumber-1}}"
          @click.native="scrollTop"
          rel="prev"
        >Previous</router-link>
      </li>

      <li
        v-for="pageNo in pageRange"
        :key="pageNo.number"
        :class="{current: (pageNo.number == $route.query.page)|| (!$route.query.page && pageNo.number == 1)}"
      >
        <router-link
          class="page-link"
          :to="{query:{...$route.query, page: (pageNo.number == 1) ? undefined: pageNo.number}}"
          @click.native="scrollTop"
        ><span v-if="pageNo.continuation == 'prev'">...</span>{{pageNo.number}}<span v-if="pageNo.continuation == 'next'">...</span></router-link>
      </li>

      <li :class="{disabled: pageNumber >= pageCount -1}" v-if="pageNumber < pageCount">
        <router-link
          class="page-link"
          :to="{query:{...this.$route.query, page: pageNumber+1}}"
          @click.native="scrollTop"
          rel="next"
        >Next</router-link>
      </li>
      <li :class="{disabled: pageNumber >= pageCount -1}" v-if="pageNumber < pageCount">
        <router-link
          class="page-link"
          :to="{query:{...this.$route.query, page: pageCount}}"
          @click.native="scrollTop"
          rel="nofollow"
        >Last</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { isInViewport } from "@/utils";

export default {
  name: "PaginationButtons",
  components: {},
  props: ["pageCount", "pageNumber"],
  methods: {
    scrollTop() {
      // will scroll element with ID scrollTo if exists
      // otherwise will scroll to top.
      var elmnt = document.getElementById("scrollTo");
      if (elmnt) {
        if (!isInViewport(elmnt)) {
          //only scroll if element isn't already in view
          elmnt.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      } else {
        window.scroll({
          top: 0,
          behavior: "smooth"
        });
      }
    }
  },
  computed:{
    pageRange(){
      //page range is either 1 to pageCount, or at most 5 either side of current page number
      let start = Math.max(1, this.pageNumber - 5);
      let end = Math.min(this.pageCount, this.pageNumber + 5);

      let pageRange = [];
      for(let i=start; i<= end; i++){
        let continuation = false;
        if(i == start && start != 1){
          continuation = "prev";
        }else if(i == end && end != this.pageCount){
          continuation = "next";
        }
        pageRange.push({number: i, continuation});
      }

      return pageRange;
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  padding: 20px;
  padding-bottom:0px;
  li {
    display: inline-block;
    a {
      padding: 10px;
      color: darken($CTgrey, 40%);
    }

    &.current {
      text-decoration: underline;
    }
  }
}
</style>
